import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import jp from "jsonpath";
import _ from 'lodash';
import { ApiResponse } from 'src/api';

export function isReferenceObject(
    response: any
): response is OpenAPI.ReferenceObject {
    return (response as OpenAPI.ReferenceObject).$ref !== undefined;
}

export function isApiResponseObject(
    response: any
): response is ApiResponse {
    return (response as ApiResponse).status !== undefined;
}

export const resolve: <T>(
    obj: T | OpenAPI.ReferenceObject,
    document: OpenAPI.Document
) => T = (obj, document) => {
    let resolved: any = obj;
    if (isReferenceObject(obj)) {
        const { $ref } = obj;
        const path = $ref.replace(/#/g, '$').replace(/\//g, '.');
        resolved = jp.value(document, path);
    }
    return resolved;
}

export const resolveAll: <T>(
    arr: Array<T | OpenAPI.ReferenceObject>,
    document: OpenAPI.Document

) => Array<T> = (arr, document) => {

    let resolved = arr.map(obj => resolve(obj, document));
    return resolved;
}

export const getParams: (
    pathItemObj: OpenAPI.PathItemObject,
    operationObj: OpenAPI.OperationObject,
    document: OpenAPI.Document
) => OpenAPI.ParameterObject[] = (
    pathItemObj,
    operationObj,
    document
) => _.concat(
    Array.isArray(pathItemObj.parameters) ? resolveAll(pathItemObj.parameters, document) : [],
    Array.isArray(operationObj.parameters) ? resolveAll(operationObj.parameters, document) : []
)

type PropType = "array" | OpenAPI.NonArraySchemaObjectType;

const getAutoExample: (propType: PropType | PropType[]) => any = (propType) => {
    let example: any = '';
    switch (propType) {
        case 'string':
            example = 'string';
            break;
        case 'integer':
            example = 1;
            break;
        case 'boolean':
            example = false;
            break;
    }
    return example;
}

export const getRequestBody: (
    mediaTypeObj: OpenAPI.MediaTypeObject,
    document: OpenAPI.Document
) => string = (
    mediaTypeObj,
    document
) => {
        const { example, schema } = mediaTypeObj;
        const schemaObj: OpenAPI.SchemaObject = resolve(schema, document)!

        if (example) {
            return schemaObj.type === 'string' ? example : JSON.stringify(_.cloneDeep(example), undefined, 2);
        }

        if (schemaObj.type === 'string') {
            let body: string = '';

            if (schemaObj.format === 'uri') {
                body = '/abc/1';
            } else if (schemaObj.format === 'uri-list') {
                body = '/abc/1\n/abc/2';
            }

            return body;

        } else {
            const body: any = {};

            _.keys(schemaObj.properties).reduce((acc, prop) => {
                const propSchema: OpenAPI.SchemaObject = resolve(schemaObj.properties![prop], document);
                acc[prop] = propSchema.example ?? getAutoExample(propSchema.type!);
                return acc;
            }, body);

            return JSON.stringify(body, undefined, 2);
        }
    }

export const getRequestBodyModel: (
    schemaObj: OpenAPI.SchemaObject,
    document: OpenAPI.Document
) => any = (
    schemaObj,
    document
) => {
        if (schemaObj.type === 'array') {
            const body: any[] = [];

            body.push(getRequestBodyModel(resolve(schemaObj.items, document), document));

            return body;

        } else if (schemaObj.type === 'object') {
            const body: any = {};

            _.keys(schemaObj.properties).reduce((acc, prop) => {
                const propSchema: OpenAPI.SchemaObject = resolve(schemaObj.properties![prop], document);

                let spec = propSchema.type!.toString();

                if (propSchema.enum) {
                    spec = 'enum: (' + propSchema.enum.reduce(
                        (acc, item, index, arr) => {
                            return acc + item + (index < (arr.length - 1) ? ',' : '')
                        },
                        ''
                    ) + ')'
                } else if (propSchema.pattern) {
                    spec = 'string: (' + propSchema.pattern + ')';
                }

                acc[prop] = spec;

                return acc;
            }, body);

            return body;
        }
    }

export const getResponseExample: (
    schemaObj: OpenAPI.SchemaObject,
    document: OpenAPI.Document
) => any = (
    schemaObj,
    document
) => {
        // return getRequestBody(schemaObj, document);
        return {};
    }

export const getResponseModel: (
    schemaObj: OpenAPI.SchemaObject,
    document: OpenAPI.Document
) => any = (
    schemaObj,
    document
) => {
        return getRequestBodyModel(schemaObj, document);
    }




